/**
 * Interface para serviços de rede
 */

import { BasePlatformService } from './base_platform_service';

export enum ConnectionType {
  UNKNOWN = 'unknown',
  ETHERNET = 'ethernet',
  WIFI = 'wifi',
  CELLULAR = 'cellular',
  BLUETOOTH = 'bluetooth',
  WIMAX = 'wimax',
  OTHER = 'other',
  NONE = 'none'
}

export enum EffectiveType {
  SLOW_2G = 'slow-2g',
  TWO_G = '2g',
  THREE_G = '3g',
  FOUR_G = '4g'
}

export interface NetworkInfo {
  isOnline: boolean;
  type: ConnectionType;
  effectiveType: EffectiveType;
  downlink: number;
  rtt: number;
  saveData: boolean;
  timestamp: number;
}

export interface NetworkEvent {
  type: 'online' | 'offline' | 'change';
  info: NetworkInfo;
  timestamp: number;
}

export type NetworkEventListener = (event: NetworkEvent) => void;

export interface ConnectivityTestResult {
  isReachable: boolean;
  responseTime: number;
  error?: string;
}

export interface QualityMonitorResult {
  averageRtt: number;
  successRate: number;
  samples: number;
}

export interface OptimizationRecommendations {
  preloadImages: boolean;
  useWebP: boolean;
  enableAutoplay: boolean;
  maxVideoQuality: string;
  batchRequests: boolean;
}

export interface INetworkService extends BasePlatformService {
  readonly serviceName: 'Network';
  
  getNetworkInfo(): NetworkInfo;
  isOnline(): boolean;
  isOffline(): boolean;
  addListener(listener: NetworkEventListener): () => void;
  removeListener(listener: NetworkEventListener): void;
  removeAllListeners(): void;
  testConnectivity(url?: string, timeout?: number): Promise<ConnectivityTestResult>;
  monitorQuality(duration?: number, interval?: number): Promise<QualityMonitorResult>;
  isFastConnection(): boolean;
  isSlowConnection(): boolean;
  shouldSaveData(): boolean;
  getOptimizationRecommendations(): OptimizationRecommendations;
}
